<template>
  <div class="navbar-bookmarks flex items-center">
    <div class="bookmark-container">
      <feather-icon
        icon="StarIcon"
        :svgClasses="['stoke-current text-warning', textColor]"
        class="cursor-pointer p-2"
        @click.stop="showBookmarkPagesDropdown = !showBookmarkPagesDropdown"
      />
      <div
        v-click-outside="outside"
        class="absolute bookmark-list w-1/3 xl:w-1/4 mt-4"
        v-if="showBookmarkPagesDropdown"
      >
        <vx-auto-suggest
          ref="bookmarkAutoSuggest"
          :autoFocus="true"
          :data="navbarSearchAndPinList"
          :initalData="{ pages: starredPagesLimited.concat(starredPagesMore) }"
          :searchLimit="5"
          placeholder="Explore Vuexy..."
          inputClassses="w-full"
          show-action
          show-pinned
          hideGroupTitle
          background-overlay
          @input="hnd_search_query_update"
          @selected="selected"
        >
          <template v-slot:pages="{ suggestion }">
            <div class="flex items-center justify-between">
              <div class="flex items-end leading-none py-1">
                <feather-icon
                  :icon="suggestion.icon"
                  svgClasses="h-5 w-5"
                  class="mr-4"
                />
                <span class="mt-1">{{ suggestion.title }}</span>
              </div>
              <feather-icon
                icon="StarIcon"
                :svgClasses="[
                  { 'text-warning': suggestion.is_bookmarked },
                  'h-5 w-5 stroke-current mt-1',
                ]"
                @click.stop="actionClicked(suggestion)"
              />
            </div>
          </template>
        </vx-auto-suggest>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import VxAutoSuggest from "@/components/vx-auto-suggest/VxAutoSuggest.vue";
export default {
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },
  components: {
    draggable,
    VxAutoSuggest,
  },
  data() {
    return {
      showBookmarkPagesDropdown: false,
      horizonalMenu: [
        {
          icon: "UserIcon",
          title: "Leader",
          url: "/leader",
        },
        {
          icon: "ClipboardIcon",
          title: "Inventery",
          url: "/inventery",
        },
        {
          icon: "UsersIcon",
          title: "Customers",
          url: "/customers",
        },
        {
          icon: "TagIcon",
          title: "Tickets",
          url: "/tickets",
        },
        {
          icon: "UserCheckIcon",
          title: "Business Entity",
          url: "/businessEntity",
        },
        {
          icon: "FileTextIcon",
          title: "Accounting",
          url: "/accounting",
        },
      ],
      reportDropdown: [
        {
          title: "All",
          url: "/all",
        },
        {
          title: "Clients",
          url: "/clients",
        },
        {
          title: "Orders",
          url: "/orders",
        },
        {
          title: "Tickets",
          url: "/tickets",
        },
        {
          title: "Inventory",
          url: "/inventory",
        },
        {
          title: "Leads",
          url: "/leads",
        },
        {
          title: "BroadCaster",
          url: "/broad_caster",
        },
        {
          title: "AccessProfile",
          url: "/access_profile",
        },
        {
          title: "Organization",
          url: "/organization",
        },
        {
          title: "Invoice&Collections",
          url: "/invoice&collections",
        },
      ],
      adminDropdown: [
        {
          title: "System",
          url: "/system",
        },
        {
          title: "Masters",
          url: "/setup",
        },
        {
          title: "Accounting",
          url: "/accounting",
        },
        {
          title: "Bulk Uploads",
          url: "/bulk_uploads",
        },
        {
          title: "Provisioning Status",
          url: "/provisioning_status",
        },
        {
          title: "Create Item",
          url: "/create_item",
        },
        {
          title: "createContract",
          url: "/createContract",
        },
        {
          title: "Scheduler Jobs",
          url: "/scheduler_jobs",
        },
        {
          title: "Online Payment",
          url: "/online_payments",
        },
        {
          title: "Command Center",
          url: "/command_center",
        },
        {
          title: "Provisioning Orders",
          url: "/provisioning_orders",
        },
        {
          title: "Hooks(EventActions)",
          url: "/eventaction",
        },
        {
          title: "Maker Checker",
          url: "/makerchecker",
        },
      ],
    };
  },
  watch: {
    $route() {
      if (this.showBookmarkPagesDropdown)
        this.showBookmarkPagesDropdown = false;
    },
  },
  computed: {
    navbarSearchAndPinList() {
      return { pages: this.$store.state.navbarSearchAndPinList["pages"] };
    },
    starredPages() {
      return this.$store.state.starredPages;
    },
    starredPagesLimited: {
      get() {
        return this.starredPages.slice(0, 10);
      },
      set(list) {
        this.$store.dispatch("arrangeStarredPagesLimited", list);
      },
    },
    starredPagesMore: {
      get() {
        return this.starredPages.slice(10);
      },
      set(list) {
        this.$store.dispatch("arrangeStarredPagesMore", list);
      },
    },
    textColor() {
      return {
        "text-white":
          this.$store.state.mainLayoutType === "vertical" &&
          this.navbarColor !=
            (this.$store.state.theme === "dark" ? "#10163a" : "#fff"),
      };
    },
  },
  methods: {
    selected(obj) {
      this.$store.commit("TOGGLE_CONTENT_OVERLAY", false);
      this.showBookmarkPagesDropdown = false;
      this.$router.push(obj.pages.url).catch(() => {});
    },
    actionClicked(item) {
      this.$store.dispatch("updateStarredPage", {
        url: item.url,
        val: !item.is_bookmarked,
      });
    },
    outside: function () {
      this.showBookmarkPagesDropdown = false;
    },
    hnd_search_query_update(query) {
      this.$store.commit("TOGGLE_CONTENT_OVERLAY", query ? true : false);
    },
  },
  directives: {
    "click-outside": {
      bind: function (el, binding) {
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;
        document.addEventListener("click", handler);
      },
      unbind: function (el) {
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      },
    },
  },
};
</script>
